import React, { useEffect, useState } from 'react';
import logo from '../../assets/CuidatiaNuevo2026.png';
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';
import { Checkbox } from '@material-ui/core';
import ToastNotification from '../../hooks/ToastNotification';
import { get } from 'react-scroll/modules/mixins/scroller';

export const FormularioRegistroEmpresa = (props) => {
    const [showToast, setShowToast] = useState(false);
    const {empresa, setEmpresa, ListaLocalidades, setLocalidadSede, CategoriasPosibles, sedesEmpresa, setSedesEmpresa, crearUsuario, handleInpuntChange, getPresatadorPorEmail, getPresatadorPorTelefono} = props;
    const [ localidadesOpciones, setLocalidadesOpciones ] = useState();
    const [ categoriasOpciones, setCategoriasOpciones ] = useState();
    const [ PoliticaPrivacidad, setPoliticaPrivacidad ] = useState(false);
    const [ enviando, setEnviando ] = useState(false);
    const navigate = useNavigate();

    const [showPassword, setShowPassword] = useState(false);
    const mostrarPassword = () => setShowPassword(!showPassword);
    
    const [showPassword2, setShowPassword2] = useState(false);
    const mostrarPassword2 = () => setShowPassword2(!showPassword2);

    const [ erroresFormulario, setErroresFormulario ] = useState({
        emailEmpresa: '',
        constraseña: '',
        nombreEmpresa: '',
        categoria: '',
        nombreContactoEmpresa: '',
        apellidosContactoEmpresa: '',
        telefono: '',
        localidad: ''
    });

    useEffect(() => {
        if (ListaLocalidades && ListaLocalidades.length > 0) {
            const opciones = ListaLocalidades.map(localidad => ({
                value: localidad.id,
                label: localidad.nombre
            }));
            setLocalidadesOpciones(opciones);
        } else {
            setLocalidadesOpciones([]);
        }
        if (CategoriasPosibles && CategoriasPosibles.length > 0) {
            const opciones = CategoriasPosibles.map(categoria => ({
                value: categoria.id,
                label: categoria.nombre
            }));
            setCategoriasOpciones(opciones);// Asignar la primera categoría por defecto
        } else {
            setCategoriasOpciones([]);
        }
    }, [ListaLocalidades, CategoriasPosibles]);

    

    const [localidadSeleccionada, setLocalidadSeleccionada] = useState(null);

    const seleccionarLocalidad = (option) => {
        setLocalidadSeleccionada(option);
        let localidad = ListaLocalidades.find(localidad => localidad.id === option.value);
        setEmpresa({...empresa, localidad: localidad, codigoPostal: localidad.codigoPostal}); // Actualizar el estado de la empresa con la localidad seleccionada
        console.log('Selected:', localidad);
    };

    const [categoriaSeleccionada, setCategoriaSeleccionada] = useState(null);

    const seleccionarCategoria = (option) => {
        setCategoriaSeleccionada(option);
        let categoria = CategoriasPosibles.find(categoria => categoria.id === option.value);
        setEmpresa({...empresa, categoria: categoria}); // Actualizar el estado de la empresa con la categoría seleccionada
        console.log('Selected:', categoria);
    };

const manejarErroresFormulario = async () => {
    const nuevosErrores = {};

    if (!empresa.emailEmpresa) {
        nuevosErrores.emailEmpresa = 'El email es obligatorio';
    }
    let emailExiste = await getPresatadorPorEmail(empresa.emailEmpresa);
    if (!emailExiste) {
        nuevosErrores.emailEmpresa = 'Ya existe un usuario con este email';
    }

    if (!empresa.constraseña || !empresa.repitaConstraseña) {
        nuevosErrores.constraseña = 'La contraseña es obligatoria';
    } else if (empresa.constraseña !== empresa.repitaConstraseña) {
        nuevosErrores.constraseña = 'Las contraseñas no coinciden';
    }

    if (!empresa.nombreEmpresa) {
        nuevosErrores.nombreEmpresa = 'El nombre de la empresa es obligatorio';
    }

    if (!categoriaSeleccionada) {
        nuevosErrores.categoriaSeleccionada = 'Debes seleccionar una categoría';
    }

    if (!empresa.nombreContactoEmpresa || !empresa.apellidosContactoEmpresa) {
        nuevosErrores.nombreContactoEmpresa = 'El nombre y los apellidos de contacto son obligatorios';
    }

    if (!empresa.telefono) {
        nuevosErrores.telefono = 'El teléfono es obligatorio';
    }

    let telefonoExiste = await getPresatadorPorTelefono(empresa.telefono);
    if (!telefonoExiste) {
        nuevosErrores.telefono = 'Ya existe un usuario con este teléfono';
    }

    if (!localidadSeleccionada) {
        nuevosErrores.localidadSeleccionada = 'Debes seleccionar una localidad';
    }

    if (!PoliticaPrivacidad) {
        nuevosErrores.politicaPrivacidad = 'Debes aceptar la política de privacidad';
    }

    // Actualizar errores
    setErroresFormulario(nuevosErrores);

    // Si no hay errores, crear usuario
    if (Object.keys(nuevosErrores).length === 0) {
        setEnviando(true);
        crearUsuario();
    }
};


    return (
        <div className="">
            <div className="row min-vh-80">
                <div className="col-lg-4 d-none d-lg-block logoLateral">
                <div className="centrador text-center">
                    <img src={logo} alt="Logo" className="img-fluid w-100" />
                </div>
                </div>

                <div className="col-lg-8 col-md-12 d-flex align-items-center justify-content-center">
                <div className="w-100" style={{ maxWidth: '530px', backgroundColor: '#fff', padding: '2rem', borderRadius: '12px', boxShadow: '0 0 15px rgba(0,0,0,0.05)'  }}>
                    <h2 className="mb-4">
                        Área de Profesionales
                    </h2>

                    {/* Email */}
                    <div className="mb-3">
                    <label htmlFor="emailEmpresa" className="form-label">Email</label>
                    <input
                        type="email"
                        id="email"
                        name="emailEmpresa"
                        className={`form-control text-dark ${erroresFormulario.emailEmpresa ? "border border-danger" : ""}`}	
                        placeholder="email@ejemplo.com"
                        onChange={handleInpuntChange}
                        value={empresa.emailEmpresa}
                    />
                    {
                        erroresFormulario.emailEmpresa &&
                        <div className="text-danger small mt-1">
                            {erroresFormulario.emailEmpresa}
                        </div>
                    }
                    </div>

                    {/* Contraseña */}
                    <div className="row mb-3">
                    <div className="col-md-6 mb-1">
                        <label htmlFor="constraseña" className="form-label">Contraseña</label>
                        <div className='input-group'>
                            <input
                                type={showPassword ? 'text' : "password"}
                                id="password"
                                name="constraseña"
                                className={`form-control text-dark ${erroresFormulario.constraseña ? "border border-danger" : ""}`}
                                placeholder="********"
                                onChange={handleInpuntChange}
                                value={empresa.constraseña}
                                />
                            <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={mostrarPassword}
                                tabIndex={-1}
                                >
                                {showPassword ? "Ocultar" : "Mostrar"}
                            </button>
                        </div>
                    </div>
                    <div className="col-md-6 mb-1">
                        <label htmlFor="repitaConstraseña" className="form-label">Confirmar contraseña</label>
                        <div className='input-group'>
                            <input
                                type={showPassword2 ? 'text' : "password"}
                                id="repeatPassword"
                                name="repitaConstraseña"
                                className={`form-control text-dark ${erroresFormulario.constraseña ? "border border-danger" : ""}`}
                                placeholder="********"
                                onChange={handleInpuntChange}
                                value={empresa.repitaConstraseña}
                                />
                            <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={mostrarPassword2}
                                tabIndex={-1}
                                >
                                {showPassword2 ? "Ocultar" : "Mostrar"}
                            </button>
                        </div>
                        
                    </div>
                    {
                        erroresFormulario.constraseña &&
                        <div className="text-danger small mt-1">
                            {erroresFormulario.constraseña}
                        </div>
                    }               
                    <small className="text-muted">
                        La contraseña debe tener al menos 6 caracteres, una mayúscula, una minúscula y un número.
                    </small>
                    </div>

                    {/* Nombre de la empresa */}
                    <div className="mb-3">
                    <label htmlFor="nombreEmpresa" className="form-label">Nombre de la empresa</label>
                    <input
                        type="text"
                        id="empresa"
                        name="nombreEmpresa"
                        className={`form-control text-dark ${erroresFormulario.nombreEmpresa ? "border border-danger" : ""}`}
                        placeholder="Nombre de la empresa"
                        onChange={handleInpuntChange}
                        value={empresa.nombreEmpresa}
                    />
                    {
                        erroresFormulario.nombreEmpresa &&
                        <div className="text-danger small mt-1">
                            {erroresFormulario.nombreEmpresa}
                        </div>
                    }
                    </div>

                    <div className="mb-3">
                        <label htmlFor="Categoría" className="form-label">Categoría</label>
                        <Select
                            className={`${erroresFormulario.categoriaSeleccionada ? "border border-danger" : ""}`}
                            options={categoriasOpciones}
                            value={categoriaSeleccionada}
                            onChange={seleccionarCategoria}
                            placeholder="Categoría"
                            isClearable
                        />
                        {
                        erroresFormulario.categoriaSeleccionada &&
                        <div className="text-danger small mt-1">
                            {erroresFormulario.categoriaSeleccionada}
                        </div>
                    }
                    </div>

                    {/* Contacto: nombre y apellidos */}
                    <div className="row mb-3">
                    <div className="col-md-6 mb-1">
                        <label htmlFor="nombreContactoEmpresa" className="form-label">Nombre de contacto</label>
                        <input
                        type="text"
                        id="nombreContacto"
                        name="nombreContactoEmpresa"
                        className={`form-control text-dark ${erroresFormulario.nombreContactoEmpresa ? "border border-danger" : ""}`}
                        placeholder="Nombre"
                        onChange={handleInpuntChange}
                        value={empresa.nombreContactoEmpresa}
                        />
                    </div>
                    <div className="col-md-6 mb-1">
                        <label htmlFor="apellidosContactoEmpresa" className="form-label">Apellidos de contacto</label>
                        <input
                        type="text"
                        id="apellidosContacto"
                        name="apellidosContactoEmpresa"
                        className={`form-control text-dark ${erroresFormulario.nombreContactoEmpresa ? "border border-danger" : ""}`}
                        placeholder="Apellidos"
                        onChange={handleInpuntChange}
                        value={empresa.apellidosContactoEmpresa}
                        />
                    </div>
                    {
                        erroresFormulario.nombreContactoEmpresa &&
                        <div className="text-danger small mt-1">
                            {erroresFormulario.nombreContactoEmpresa}
                        </div>
                    }
                    </div>

                    {/* Teléfono y Localidad */}
                    <div className="row">
                    <div className="col-md-6 mb-3">
                        <label htmlFor="telefono" className="form-label">Teléfono</label>
                        <input
                        type="tel"
                        id="telefono"
                        name="telefono"
                        className={`form-control text-dark ${erroresFormulario.telefono ? "border border-danger" : ""}`}
                        placeholder="600 000 000"
                        onChange={handleInpuntChange}
                        value={empresa.telefono}
                        />
                        {
                        erroresFormulario.telefono &&
                        <div className="text-danger small mt-1">
                            {erroresFormulario.telefono}
                        </div>
                    }
                    </div>
                    <div className="col-md-6 mb-3">
                        <label htmlFor="localidad" className="form-label">Localidad</label>
                        <Select
                            className={`text-dark ${erroresFormulario.localidadSeleccionada ? "border border-danger" : ""}`}
                            options={localidadesOpciones}
                            value={localidadSeleccionada}
                            onChange={seleccionarLocalidad}
                            placeholder="Localidad"
                            isClearable
                        />
                        {
                        erroresFormulario.localidadSeleccionada &&
                            <div className="text-danger small mt-1">
                                {erroresFormulario.localidadSeleccionada}
                            </div>
                        }
                    </div>
                    </div>

                    <div className='politica-privacidad'>
                        <div className='centrador'>
                            <Checkbox
                                checked={PoliticaPrivacidad}
                                onChange={(event) => setPoliticaPrivacidad(!PoliticaPrivacidad)}
                                sx={{color: '23C290', '&.Mui-checked': {color: '#23C290'}}}
                            />
                        </div>
                        <div
                            className='link-politica-privacidad-empresas centrador'
                            onClick={() => navigate('/politica-privacidad')}
                        >
                            Acepto la política de privacidad
                        </div>
                    </div>
                    {
                    erroresFormulario.politicaPrivacidad &&
                        <div className="text-danger small mt-1">
                            {erroresFormulario.politicaPrivacidad}
                        </div>
                    }

                    {/* Botón de Registro */}
                    <div className="d-grid mt-4">
                        <button className="btn btn-primary fw-bold"
                            disabled={enviando}
                            onClick={() => {
                                manejarErroresFormulario();
                            }}
                        >
                            Registrarse
                        </button>
                    </div>
                    <div className='separador my-3' />
                    <div className='link-politica-privacidad-empresas centrador '>
                        <div
                            onClick={()=>navigate('/login')}
                        >
                            <b>Inicie sesión aquí</b>
                        </div>
                    </div>
                </div>
                </div>
                <ToastNotification
                    message="El usuario a sido creado correctamente"
                    show={showToast}
                    onClose={() => setShowToast(false)}
                    type="success"
                />
            </div>
            </div>
    );
}